import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'balance',
    name: 'Balance',
    component: () => import('~/views/balance/lists/SmBalance.vue'),
    meta: {
      title: 'Баланс',
    }
  },
];